import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SearchBar from "../../components/SearchBar";
import adminTaskGraph from "../../assets/images/admin-task-graph.png";
import Sidebar from "./AdminComponents/Sidebar";
import { Link } from "react-router-dom";

const AdminTasks = () => {
  const [activeTab, setActiveTab] = useState("follow");
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Sidebar />}
        </div>
      </div>

      <div className="flex justify-start mt-8 ml-4">
        <p className="text-[18px]">Task Overview</p>
      </div>

      <div className="flex justify-between w-[95%] ml-4 mt-4">
        <p className="text-[16px] font-bold">All Tasks</p>

        <div className="flex items-center px-4 bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2 text-[#3485BB]">
          <div className="text-[12px]">Action</div>
          <span className="text-md ml-2 mb-3 font-semibold">&#x2304;</span>
        </div>
      </div>

      <div className="flex w-[90%] justify-between overflow-auto mt-4 ml-4">
        <div
          className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
            activeTab === "follow" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
          }`}
          onClick={() => setActiveTab("follow")}
        >
          <p className="font-bold text-[24px]">02</p>
          <p className="text-[16px] text-[#91929E]">Follow Ups</p>
        </div>
        <div
          className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
            activeTab === "pending" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
          }`}
          onClick={() => setActiveTab("pending")}
        >
          <p className="font-bold text-[24px]">04</p>
          <p className="text-[16px] text-[#91929E]">Pending Visits</p>
        </div>
        <div
          className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
            activeTab === "docs" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
          }`}
          onClick={() => setActiveTab("docs")}
        >
          <p className="font-bold text-[24px]">03</p>
          <p className="text-[16px] text-[#91929E]">Send Docs</p>
        </div>
        <div
          className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
            activeTab === "sample" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
          }`}
          onClick={() => setActiveTab("sample")}
        >
          <p className="font-bold text-[24px]">03</p>
          <p className="text-[16px] text-[#91929E]">sample Text</p>
        </div>
      </div>

      <div className="ml-4 mt-4">
        <img src={adminTaskGraph} alt="pie chart" />
      </div>
      <Link
        to="/admin/tasks/create-task"
        className="w-[95%] ml-4 mt-8 rounded-lg border border-[#2F80ED] flex items-center justify-center cursor-pointer"
      >
        <p className="text-[14px] text-[#2F80ED] p-2 font-bold">
          Create new task
        </p>
      </Link>
    </div>
  );
};

export default AdminTasks;
